/**
 * Client Breakthrough Carousel
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="p2-client-breakthroughs-carousel"></div>
 */

 import 'slick-carousel';

 $( function() {
     $( '[data-component="p2-client-breakthroughs-carousel"]' ).each( function() {
         let $holder = $( this );
         let $more = $( '.js-more-testimonial' );
 
         $holder.slick(
             {
                 rows: 0,
                 dots: false,
                 infinite: true,
                 arrows: true,
                 prevArrow: '<button class="slick-prev" aria-label="Previous" type="button"><i class="icon-p2-left"></i></button>',
                nextArrow: '<button class="slick-next" aria-label="Next" type="button"><i class="icon-p2-right"></i></button>',
                 slidesToShow: 2,
                 slidesToScroll: 2,
                 focusOnSelect: true,
                 focusOnChange: true,
                 responsive: [
                    //  {
                    //      breakpoint: 992,
                    //      settings: {
                    //          slidesToShow: 2,
                    //          slidesToScroll: 1,
                    //          variableWidth: true,
                    //         //  margin:20,
                    //      },
                    //  },
                     {
                         breakpoint: 600,
                         settings: {
                             slidesToShow: 1,
                             slidesToScroll: 1,
                            //  variableWidth: true,
                         },
                     },
                 ],
             }
         );
 
         $more.click( function( e ) {
             e.preventDefault();
 
             $( this ).parent().addClass( 'is-active' );
         } );
     } );
 } );
 